import { isSameObj } from './trackerUtil'
import ScrollImpController from './ScrollImpController'
import PreLoadImpController from '../js/PreLoadImpController'
import SA from './initTracker'
export { default as sensorsdata} from '../util/sensorsdata.min.js'


// 埋点事件类型
const TRACK_EVENT_TYPE = {
    ELEMENT_IMP: 'h5_element_imp',
    PAGE_IMP: 'h5_page_imp',
    SCREEN_SHOT: 'screen_shot',
    CLK: 'h5_clk',
    INPUT: 'h5_input',
    AUTH: 'h5_auth',
    BANNER_CLK: 'h5_banner_clk'
}

// 曝光类型
const IMP_TYPE = {
    SCROLL_IMP: 'scroll_imp',
    PRELOAD_IMP: 'preload_imp',
    NORMAL_IMP: 'normal_imp'
}

class PPDTracker{
    constructor({
                    STAY_TIME = 2000,
                    EXPOSED_PERCENT = 0.5,
                    isHalfAppPage = false,
                    clearPointsWhenResumed = false
                }){
        this.pageState = (window.PPDWebUI && window.PPDWebUI.pageState) || 'created'; // 页面状态
        this.scrollImpArray = []; // 待滚动曝光数组
        this.exposureScrollArray = []; // 已滚动曝光数据
        this.isHalfAppPage = isHalfAppPage;
        this.STAY_TIME = STAY_TIME;
        this.EXPOSED_PERCENT = EXPOSED_PERCENT;
        this.sensorsTrack = this.sensorsTrack.bind(this);
        this.sensorsImpTrack = this.sensorsImpTrack.bind(this);
        this.clearScrollImpArray = this.clearScrollImpArray.bind(this);
        this.login = this.login.bind(this);
        this.trackScreenShot = this.trackScreenShot.bind(this);
        this.track = this.track.bind(this);
        this.triggerScrollImp = this.triggerScrollImp.bind(this);
        this.preLoadImpController = new PreLoadImpController({
            track: this.sensorsImpTrack,
            resumedCallback: () => {
                clearPointsWhenResumed && this.clearScrollImpArray();
            }
        });
        this.screenShotParams = '';
    }

    sensorsImpTrack(params) {
        this.sensorsTrack(TRACK_EVENT_TYPE.ELEMENT_IMP, params)
    }

    clearScrollImpArray() {
        this.scrollImpArray.length = 0;
        this.exposureScrollArray.length = 0;
    }

    login() {
        SA.login();
    }

    track(eventType, params, eventParams) {
        switch (eventType) {
            case TRACK_EVENT_TYPE.ELEMENT_IMP:
                this.trackEleImp(eventType, params, eventParams);
                break;
            case TRACK_EVENT_TYPE.PAGE_IMP:
                this.trackPageImp(eventType, params, eventParams);
                break;
            case TRACK_EVENT_TYPE.SCREEN_SHOT:
                this.trackScreenShot(params);
                break;
            default:
                this.trackClkImp(eventType, params, eventParams);
                break;
        }
    }

    trackEleImp(eventType, params, eventParams) {
        if (eventParams && eventParams.impType === IMP_TYPE.SCROLL_IMP) {
            this.storeScrollImp(params, eventParams)
        } else if(eventParams && eventParams.impType === IMP_TYPE.PRELOAD_IMP) {
            // this.preLoadImpQueue.push(params);
            this.preLoadImpController.trackPreLoadImp(eventType, params, eventParams);
        } else {
            this.sensorsTrack(eventType, params)
        }
    }

    trackScreenShot(params) {
        this.screenShotParams = params;
    }

    trackPageImp(eventType, params, eventParams) {
        if (eventParams && eventParams.impType === IMP_TYPE.PRELOAD_IMP) {
            this.preLoadImpController.trackPreLoadImp(eventType, params, eventParams);
        } else {
            this.sensorsTrack(eventType, params)
        }
    }

    trackClkImp(eventType, params, eventParams) {
        this.sensorsTrack(eventType, params)
    }

    sensorsTrack(eventType, params) {
        SA[eventType] && SA[eventType](params);
    }

    storeScrollImp(params, eventParams) {
        if (!this.scrollImpController) {
            this.scrollImpController = new ScrollImpController({
                STAY_TIME: this.STAY_TIME,
                EXPOSED_PERCENT: this.EXPOSED_PERCENT,
                isHalfAppPage: this.isHalfAppPage,
                scrollImpArray: this.scrollImpArray,
                exposureScrollArray: this.exposureScrollArray,
                sensorsTrack: this.sensorsImpTrack,
            });
        }

        if (this.exposureScrollArray.length) {
            // 已曝光数组中已存在return
            for (let item of this.exposureScrollArray) {
                if (isSameObj(item, params)) {
                    return;
                }
            }
        }
        // 曝光配置参数放置在config中，作为埋点属性的一部分
        params.config = eventParams.mergeOption || {};
        if (this.scrollImpArray.length) {
            // 待曝光数组中已存在return
            for(let item of this.scrollImpArray) {
                if (isSameObj(item, params)) {
                    return;
                }
            }
        }
        this.scrollImpArray.push(params);
        this.scrollImpController.triggerScrollImp();
    }

    triggerScrollImp() {
        this.scrollImpController && this.scrollImpController.triggerScrollImp();
    }
}

window.PPDTracker = new PPDTracker({});

export {
    TRACK_EVENT_TYPE,
    IMP_TYPE,
    PPDTracker
}
